<template>
  <div>
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Gerenciamento das Guias de Impostos e Honorários" />

      <div class="flex flex-row-reverse items-end mb-4 gap-3">
        <b-button
          class="is-primary"
          icon-right="refresh"
          @click.native="
            () => {
              fetchEmpresasWithGuias();
              fetchUploadReport();
            }
          "
          >Atualizar Lista
        </b-button>
        <!-- <b-button
          class="is-primary ml-4"
          icon-right="email-send"
          @click.native="handleEnvioTodas"
          >Enviar Agora
        </b-button> -->

        <b-button
          class="is-success"
          icon-right="file"
          @click.native="gerarRelatorio"
          >Relatorio
        </b-button>
      </div>
    </div>

    <div class="w-full flex justify-between">
      <div class="flex justify-start w-full gap-2">
        <label class="pb-4 w-1/4">
          <Lynx-Label label="Competência" />
          <b-datepicker
            type="month"
            placeholder="Selecione a data de competência"
            icon="calendar-today"
            :month-names="monthNames"
            v-model="data_competencia"
            @input="fetchEmpresasWithGuias"
          />
        </label>

        <label class="pb-4">
          <Lynx-Label label="Data de Envio" />
          <b-datepicker
            placeholder="Selecione a data de envio"
            icon="calendar-today"
            :month-names="monthNames"
            v-model="data_envio"
            @input="fetchEmpresasWithGuias"
          />
        </label>

        <b-field label="Status" class="">
          <b-select placeholder="Selecione um status" v-model="filtros.status">
            <option
              v-for="item in status_guias"
              :value="item.id"
              :key="item.id"
            >
              {{ item.status }}
            </option>
          </b-select>
        </b-field>

        <label class="w-1/5">
          <Lynx-Label label="Carteiras" class=" " />

          <treeselect
            :multiple="true"
            :options="lista_carteiras"
            placeholder="Selecione as carteiras"
            v-model="filtros.carteiras"
          />
        </label>
        <label class="w-1/5">
          <Lynx-Label label="Regime triburario" class=" " />
          <b-select
            placeholder="Todos"
            name="form-class"
            v-model="filtros.regime_tributario"
          >
            <option :value="null">Todos</option>
            <option
              v-for="item in lista_regime_tributario"
              :key="item.id"
              :value="item.id"
            >
              {{ item.label }}
            </option>
          </b-select>
        </label>
      </div>
    </div>
    <div class="w-full flex justify-between mb-4 gap-2">
      <label class="w-1/5">
        <Lynx-Label label="IDs empresas" class=" " />

        <Lynx-Input v-model="empresas_id" />
      </label>
      <label class="w-1/5">
        <Lynx-Label label="Dia da Prioridade" class=" " />

        <Treeselect
            :multiple="true"
            :options="generateOptions()"
            placeholder="Prioridade"
            v-model="filtros.data_prioridade"
          />
      </label>

      <div
        class="flex flex-row-reverse items-end mb-4 w-1/3"
        v-if="uploadReport"
      >
        <label class="ml-4">
          <Lynx-Label label="Por paginas" class=" " />

          <b-select v-model="filtros.perPage">
            <option
              :value="perPageOption"
              v-for="perPageOption in perPageOptions"
              :key="perPageOption"
            >
              {{ perPageOption }}
            </option>
          </b-select>
        </label>

        <div class="control ml-4">
          <b-taglist attached>
            <b-tag type="is-primary" size="is-medium">Processando:</b-tag>
            <b-tag type="is-warning" size="is-medium">{{
              uploadReport.total || "..."
            }}</b-tag>
          </b-taglist>
        </div>
        <div class="control">
          <b-taglist attached>
            <b-tag type="is-primary" size="is-medium">Erros:</b-tag>
            <b-tag type="is-danger" size="is-medium">{{
              uploadReport.withError || "..."
            }}</b-tag>
          </b-taglist>
        </div>
      </div>
    </div>

    <b-table
      :data="loading ? [] : empresas"
      :columns="columns"
      :paginated="true"
      default-sort-direction="asc"
      default-sort="id"
      hoverables
      small
      :loading="loading"
      backend-pagination
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :total="pagination.total"
      :current-page="pagination.current_page"
      :per-page="pagination.per_page"
      striped
      style="font-size: 12px"
    >
      <template slot-scope="props">
        <b-table-column field="id" v-text="props.row.id" />
        <b-table-column style="width: 180px" field="prioridade_guias">
         <div    v-if="props.row.prioridade_empresa">
            <span>{{props.row.prioridade_empresa.data}}</span>
    
          </div>
          <Treeselect
            v-else
            :multiple="false"
            :options="generateOptions()"
            placeholder="Prioridade"
            v-model="props.row.prioridade_empresa"
            @input="showModalPrioridadeEmpresa($event, props.row)"
          />
        </b-table-column>
        <b-table-column style="width: 200px" field="guias">
          <div class="flex flex-wrap -mb-2">
            <div
              class="py-1 px-2 bg-neutral-300 rounded mr-2 mb-2 text-xs"
              v-for="(guia, key) in props.row.guias"
              :key="key"
              v-text="guia.tipo"
            ></div>
            <div
              class="py-1 px-2 bg-neutral-300 rounded mr-2 mb-2 text-xs"
              v-show="props.row.pagamento_cartao"
            >
              <b-icon
                size="is-small"
                type="is-success"
                icon="credit-card"
              ></b-icon>
            </div>
          </div>
        </b-table-column>
        <b-table-column field="financeiro">
          <b-switch
            :value="props.row.guia_liberacao | liberado_financeiro"
            @input="
              changeLiberacao(props.row, 'financeiro_departamento_liberacao')
            "
            :disabled="!$hasRole('Financeiro')"
          />
        </b-table-column>
        <b-table-column field="rh">
          <b-switch
            :value="props.row.guia_liberacao | liberado_rh"
            @input="changeLiberacao(props.row, 'rh_departamento_liberacao')"
            :disabled="!hasPermission('liberar guias manualmente')"
          />
        </b-table-column>
        <b-table-column field="contabilidade">
          <b-switch
            :value="props.row.guia_liberacao | liberado_contabilidade"
            @input="
              changeLiberacao(props.row, 'contabilidade_departamento_liberacao')
            "
            :disabled="!hasPermission('liberar guias manualmente')"
          />
        </b-table-column>

        <b-table-column field="inicio_atividades">
          {{ formatEnToBr(props.row.inicio_atividades) }}
        </b-table-column>

        <b-table-column field="status">
          <b-tag :type="props.row.guia_liberacao | statusType">{{
            props.row.guia_liberacao | dataEnvio
          }}</b-tag>
        </b-table-column>
        <b-table-column field="acoes">
          <div class="flex text-sm items-center">
            <a
              href="#"
              class="mr-2 bg-primary-600 rounded-full p-2"
              @click.prevent="openGuiasModal(props.row)"
            >
              <Icon-Eye class="text-neutral-100" size="4" />
            </a>

            <a
              href="#"
              class="mr-2 bg-primary-600 rounded-full p-2"
              @click.prevent="showModalSendEmail(props.row)"
            >
              <Icon-Mail class="text-neutral-100" size="4" />
            </a>
            <a
              href="#"
              class="bg-primary-600 rounded-full p-2"
              @click.prevent="rel(props.row.guia_liberacao[0].empresa)"
            >
              <Icon-Document class="text-neutral-100" size="4" />
            </a>
          </div>
        </b-table-column>
      </template>
    </b-table>
    <b-modal :active.sync="modalsendemail">
      <v-card elevation="10" height="220px" class="p-3">
        <Lynx-Title text="Motivo Envio" />

        <Lynx-Textarea
          placeholder="Digite o motivo para o envio"
          v-model="motivoenvio"
        />
        <div class="w-full flex justify-end items-start">
          <Lynx-Button
            size="small"
            :disabled="!motivoenvio"
            @click.native="sendGuia"
            >Enviar</Lynx-Button
          >
        </div>
      </v-card>
    </b-modal>
    <b-modal
      :active.sync="guiasModal"
      @close="closeGuiasModal"
      v-if="guiasModal"
    >
      <GerenciamentoGuiasDetails
        :current-empresa="currentEmpresa"
        @estornar="fetchEmpresasWithGuias"
        @atualizar="fetchEmpresasWithGuias"
      />
    </b-modal>

    <b-modal :active.sync="modalPrioridade">
      <v-card :loading="loading" elevation="10" height="220px" class="p-3">
        <Lynx-Title text="Prioridade Empresa" />

        <Lynx-Textarea
          placeholder="Digite o motivo para o envio"
          v-model="formPrioridade.motivo"
        />
        <div class="w-full flex justify-end items-start">
          <Lynx-Button :disabled="loading" size="small" @click.native="sendPrioridadeEmpresa"
            >Enviar</Lynx-Button
          >
        </div>
      </v-card>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  chageLiberacaoRequest,
  empresasWithGuiasRequest,
  getUploadReport,
  liberaGuiasRequest,
  sendGuiaRequest,
  sendGuiasRequest,
} from "@/services/requests/guias";
import {
  formatBrToEn,
  formatDateTimeToBr,
  formatEnToBr,
} from "@/utils/momentHelpers";
import { monthNames, dayNames } from "@/utils/utils";
import GerenciamentoGuiasDetails from "@/views/guias/GerenciamentoGuiasDetails";
import { hasPermission } from "@/utils/can";
import { carteirasRequest } from "../../services/requests/carteiras";
import LynxTextarea from "@/components/helpers/Textarea";
import Treeselect from "@riophae/vue-treeselect";
import {TipoDataObrigatoriedade} from "@/utils/enums/TipoDataObrigatoriedade";

export default {
  name: "GerenciamentoGuias",
  components: { GerenciamentoGuiasDetails, LynxTextarea, Treeselect },
  data() {
    return {
      monthNames,
      dayNames,

      columns: [
        {
          field: "id",
          label: "Empresa",
          sortable: true,
        },
        {
          field: "prioridade_guias",
          label: "Prioridade",
          sortable: true,
        },
        {
          field: "guias",
          label: "Guias",
          sortable: true,
        },
        {
          field: "financeiro",
          label: "Financ.",
        },
        {
          field: "rh",
          label: "RH",
        },
        {
          field: "contabilidade",
          label: "Cont.",
        },
        {
          field: "inicio_atividades",
          label: "Data Inicio",
        },
        {
          field: "status",
          label: "Status",
          sortable: true,
        },
        {
          field: "acoes",
          label: "Ações",
        },
      ],
      lista_regime_tributario: [
        { id: "SN", label: "Simples Nacional" },
        { id: "Presumido", label: "Lucro Presumido" },
        { id: "Isento", label: "Isento" },
        {
          id: "Eand",
          label: "Aguardando enquadramento no simples",
        },
        { id: "Presumido_equi", label: "presumido com equiparação" },
        {
          id: "MEI",
          label: "Microempreendedor Individual (MEI)",
        },
      ],
      status_guias: [
        { id: 0, status: "Todas" },
        { id: 1, status: "Enviado" },
        { id: 6, status: "Não enviado" },
        { id: 2, status: "Com Erro" },
        { id: 3, status: "Pendente Financeiro" },
        { id: 4, status: "Pendente RH" },
        { id: 5, status: "Pendente Contabilidade" },
        { id: 7, status: "Sem Guias" },
      ],
      filtros: {
        page: 1,
        empresas_id: [],
        carteiras: [],
        regime_tributario: null,
        status: null,
        perPage: 10,
        data_competencia: null,
        data_prioridade: null,
        data_envio: null,
      },
      data_envio: null,
      data_competencia: null,
      loading: false,
      carteiras: [],
      modalsendemail: false,
      motivoenvio: "",
      empresas: [],
      currentEmpresa: {},
      guiasModal: false,
      filter_status: null,
      uploadReport: {},
      uploadReportInterval: null,
      arrayemail: null,
      empresas_id: null,
      perPageOptions: [10, 50, 100],
      current_page: 1,
      pagination: {},
      modalPrioridade: false,
      formPrioridade: {
        empresa_id: null,
        prioridade: null,
        motivo: null,
        tipo: TipoDataObrigatoriedade.guias
      },
    };
  },
  computed: {
    ...mapGetters(["getCompetenciaDate", "getUser"]),
    dataCompetenciaComputed() {
      let data_competencia = this.data_competencia;
      return data_competencia
        ? formatBrToEn(data_competencia)
        : this.getCompetenciaDate;
    },
    lista_carteiras() {
      let carteira = this.carteiras;
      let data = [];
      for (let i = 0; i < carteira.length; i++) {
        data.push({ id: carteira[i].id, label: carteira[i].nome });
      }
      return data;
    },
    mensagem_alert() {
      return this.$store.state.prioridadeEmpresa.mensagem_alert;
    },
  },
  filters: {
    liberado_contabilidade: (val) =>
      val && val.length > 0
        ? val[0].contabilidade_departamento_liberacao
        : false,
    liberado_rh: (val) =>
      val && val.length > 0 ? val[0].rh_departamento_liberacao : false,
    liberado_financeiro: (val) =>
      val && val.length > 0 ? val[0].financeiro_departamento_liberacao : false,
    liberado: (val) => {
      if (!val || !val.length) return false;
      return (
        val[0].rh_departamento_liberacao &&
        val[0].contabilidade_departamento_liberacao
      );
    },
    dataEnvio: (val) => {
      const thereIsEnvio = val && val.length > 0 && val[0].data_envio;
      const thereIsError = val && val.length > 0 && val[0].erro_envio;
      const thereIsNoGuia = val && val.length > 0 && val[0].sem_guia;
      if (thereIsEnvio) {
        return formatDateTimeToBr(val[0].data_envio);
      }
      if (thereIsError) {
        return "Erro no envio";
      }
      if (thereIsNoGuia) {
        return "Sem guia";
      }
      return "Pendente";
    },
    statusType: (val) => {
      const thereIsEnvio = val && val.length > 0 && val[0].data_envio;
      const thereIsError = val && val.length > 0 && val[0].erro_envio;
      const thereIsNoGuia = val && val.length > 0 && val[0].sem_guia;
      if (thereIsEnvio) return "is-success";
      if (thereIsError) return "is-danger";
      if (thereIsNoGuia) return "is-warning";
      return "default";
    },

    lista_tipo_cobrancas() {
      return this.$store.state.financeiro.lista_tipo_cobrancas;
    },
  },
  mounted() {
    this.fetchCarteiras();
    this.fetchEmpresasWithGuias();
    this.fetchUploadReport();
    this.uploadReportInterval = setInterval(
      () => this.fetchUploadReport(),
      15000
    );
  },
  destroyed() {
    clearInterval(this.uploadReportInterval);
  },
  watch: {
    "filtros.perPage"() {
      this.fetchEmpresasWithGuias();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchEmpresasWithGuias();
    },
  },
  methods: {
    hasPermission,
    formatEnToBr,
    fetchCarteiras() {
      carteirasRequest()
        .then((response) => {
          const { data } = response.data;
          this.carteiras = data.filter(
            (carteira) => carteira.setor === "contabilidade"
          );
        })
        .catch((error) => this.$snack.error(error.response.data.message));
    },
    fetchUploadReport() {
      getUploadReport()
        .then((response) => (this.uploadReport = response.data))
        .catch(() => this.$snack.error("Erro ao calcular Uploads pendentes."));
    },
    async fetchEmpresasWithGuias() {
      this.loading = true;
      this.guiasModal = false
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }
      this.filtros.data_competencia = this.dataCompetenciaComputed;
      if (this.data_envio) {
        this.filtros.data_envio = formatBrToEn(this.data_envio);
      }

      const { filtros } = this;

      await empresasWithGuiasRequest(filtros)
        .then((res) => {
          this.empresas = res.data.data;
          this.pagination = res.data.pagination;
        })
        .catch(() =>
          this.$snack.error("Ocorreu um erro, tente novamente mais tarde")
        )
        .finally(() => (this.loading = false));
    },
    changeLiberacao(empresa, departamento) {
      let guiaLiberacao = empresa.guia_liberacao;
      if (
        !(
          guiaLiberacao &&
          guiaLiberacao.length &&
          guiaLiberacao[0][departamento]
        )
      ) {
        this.liberaEnvio(empresa, departamento);
        return;
      }
      this.removeLiberacaoEnvio(empresa, departamento);
    },
    isGuiaLiberadoParaEnvio(guiaLiberacao) {
      return (
        guiaLiberacao &&
        guiaLiberacao.length > 0 &&
        guiaLiberacao[0].rh_departamento_liberacao &&
        guiaLiberacao[0].contabilidade_departamento_liberacao
      );
    },
    liberaEnvio(empresa, departamento) {
      this.chageLiberacaoRequest(true, empresa, departamento);
    },
    removeLiberacaoEnvio(empresa, departamento) {
      this.chageLiberacaoRequest(false, empresa, departamento);
    },
    chageLiberacaoRequest(liberado, empresa, departamento) {
      const data = {
        [departamento]: liberado,
        empresaId: empresa.id,
        dataCompetencia: this.getCompetenciaDate,
      };
      chageLiberacaoRequest(data)
        .then(() => (empresa.guia_liberacao[0][departamento] = liberado))
        .catch((error) => {
          this.$snack.error(error.response.data.message);
          empresa.guia_liberacao[0][departamento] = !liberado;
        });
    },
    showModalSendEmail(value) {
      this.modalsendemail = true;
      this.arrayemail = value;
      this.motivoenvio = null;
    },
    sendGuia() {
      this.$buefy.dialog.confirm({
        title: "Estornar Guia",
        message: "Tem certeza que deseja enviar este email agora?",
        confirmText: "Enviar",
        cancelText: "Cancelar",
        type: "is-primary",
        hasIcon: true,
        onConfirm: () => this.onSendGuia(),
      });
    },
    onSendGuia() {
      let empresa = this.arrayemail;
      const guiaLiberacao =
        empresa.guia_liberacao && empresa.guia_liberacao.length > 0
          ? empresa.guia_liberacao[0]
          : null;
      if (!this.validateLiberacao(guiaLiberacao)) {
        return;
      }
      this.loading = true;
      const data = {
        competencia: guiaLiberacao.competencia,
        guiaLiberacaoId: guiaLiberacao.id,
        motivoenvio: this.motivoenvio,
        usuario_id: this.getUser.id,
      };
      sendGuiaRequest(data)
        .then((res) => {
          if (res.data.message == "Envio de guias com sucesso") {
            this.$snack.success(res.data.message);
          } else {
            this.$snack.error(res.data.message);
          }
          this.fetchEmpresasWithGuias();
        })
        .catch((err) =>
          this.$snack.error(err.response.data.message || err.message)
        )
        .finally(() => (this.loading = false));
    },
    validateLiberacao(guiaLiberacao) {
      if (!guiaLiberacao) {
        this.$snack.error(
          "Por favor aguarde a liberação para enviar as guias."
        );
        return false;
      }
      if (!guiaLiberacao.rh_departamento_liberacao) {
        this.$snack.error("Por favor aguarde a liberação do RH.");
        return false;
      }
      if (!guiaLiberacao.contabilidade_departamento_liberacao) {
        this.$snack.error("Por favor aguarde a liberação da Contabilidade.");
        return false;
      }
      if (!guiaLiberacao.financeiro_departamento_liberacao) {
        this.$snack.error("Por favor aguarde a liberação Financeiro.");
        return false;
      }
      return true;
    },
    openGuiasModal(empresa) {
      this.currentEmpresa = empresa;
      this.guiasModal = true;
    },
    closeGuiasModal() {
      this.guiasModal = false;
      this.currentEmpresa = {};
    },
    handleLiberacaoTodas() {
      this.$buefy.dialog.confirm({
        title: "Liberação de guias",
        message:
          "Esta ação irá liberar para envio conforme as guias que estão anexadas. Deseja continuar?",
        confirmText: "Sim",
        cancelText: "Cancelar",
        type: "is-primary",
        hasIcon: true,
        onConfirm: () => this.liberacaoTodas(),
      });
    },
    liberacaoTodas() {
      this.loading = true;
      liberaGuiasRequest(this.dataCompetenciaComputed)
        .then((response) => this.$snack.success(response.data.message))
        .catch((error) => this.$snack.error(error.response.data.message))
        .finally(() => {
          this.loading = false;
          this.fetchEmpresasWithGuias();
        });
    },
    handleEnvioTodas() {
      this.$buefy.dialog.confirm({
        title: "Liberação de guias",
        message:
          "Esta ação irá enviar todas as guias liberadas. Deseja continuar?",
        confirmText: "Sim",
        cancelText: "Cancelar",
        type: "is-primary",
        hasIcon: true,
        onConfirm: () => this.enviaTodos(),
      });
    },
    enviaTodos() {
      this.loading = true;
      sendGuiasRequest(this.dataCompetenciaComputed)
        .then((response) => this.$snack.success(response.data.message))
        .catch((error) => this.$snack.error(error.response.data.message))
        .finally(() => {
          this.loading = false;
          this.fetchEmpresasWithGuias();
        });
    },
    rel(value) {
      window.open(
        "https://api.medcontabil.com.br/relatorio/fechamento-mensal?empresa_id=" +
          value,
        "_brank"
      );
    },
    gerarRelatorio() {
      const { filtros } = this;

      const serialize = (obj) => {
        return Object.keys(obj)
          .filter((key) => obj[key] !== null && obj[key] !== undefined)
          .map((key) => {
            if (Array.isArray(obj[key])) {
              return obj[key]
                .map(
                  (item) =>
                    `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`
                )
                .join("&");
            } else {
              return `${encodeURIComponent(key)}=${encodeURIComponent(
                obj[key]
              )}`;
            }
          })
          .join("&");
      };

      const queryString = serialize(filtros);
      const url = `${process.env.VUE_APP_API_URL}/guias/relatorio/envio?token=${this.$store.getters.getToken}&${queryString}`;
      window.open(url, "_blank");
    },
    onPageChange(page) {
      this.current_page = page;
    },
    async showModalPrioridadeEmpresa(data, parametros) {
      this.formPrioridade = {
        empresa_id: parametros.id,
        data: data,
        motivo: null,
        tipo: TipoDataObrigatoriedade.guias
      };
      this.modalPrioridade = true;
    },
    async sendPrioridadeEmpresa() {
      this.loading = true;
      await this.$store.dispatch(
        "prioridadeEmpresa/create_prioridade_empresa",
        this.formPrioridade
      );
      this.empresas = this.empresas.map((empresa) => {
        if (empresa.id === this.formPrioridade.empresa_id) {
          empresa.prioridade_empresa = this.mensagem_alert.conteudo;
        }
        return empresa;
      });
      
      this.loading = false;
      this.modalPrioridade = false;
    },

    generateOptions() {
      const month = new Date().getMonth() + 1;
      const year = new Date().getFullYear();
      const daysInMonth = new Date(year, month, 0).getDate();
      let options = [];
      for (let i = 1; i <= daysInMonth; i++) {
        options.push({ id: i, label: i });
      }
      return options;
    },
  }
};
</script>
